export default __webpack_public_path__ + "static/media/thomas-schauber-transparent.236149ad.png";